import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { selectDateRange } from '../selectors'

import { CREATE_DEEPFAKE_ANALYTIC_ASYNC } from './constants'

const createDeepfakeEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(CREATE_DEEPFAKE_ANALYTIC_ASYNC.INITIATE).switchMap(() =>
    api.dashboard
      .createDeepfakeAnalytic({
        fe_date_range: selectDateRange(store.getState()),
      })
      .map(({ response }) =>
        CREATE_DEEPFAKE_ANALYTIC_ASYNC.onSuccess({
          data: response,
        })
      )
      .catch((error) =>
        Observable.of(epicsErrorHandler(CREATE_DEEPFAKE_ANALYTIC_ASYNC.onError, error))
      )
      .takeUntil(action$.ofType(CREATE_DEEPFAKE_ANALYTIC_ASYNC.CANCEL))
  )

export default combineEpics(createDeepfakeEpic)
